import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

const PILLARS = [
  { ic: "🪪", h: "Multi-level verification", p: "Every user passes ID and selfie checks with liveness detection before they can connect, so you always know who's real." },
  { ic: "⭐", h: "Reputation score", p: "Trust is earned from real interactions — not follower counts. See a member's standing before you talk." },
  { ic: "👩", h: "Women-only mode", p: "Women can switch on a discovery mode that surfaces only verified women, for a safer space to connect." },
  { ic: "🤖", h: "AI moderation", p: "Live audio and text are monitored by AI for abuse, with instant reporting and human review on every flag." },
  { ic: "📍", h: "City-level location", p: "We never share your exact location — only your city — so you stay in control of your privacy." },
  { ic: "🚫", h: "Zero tolerance", p: "Harassment, nudity, and sleaze are banned. Violations lead to instant suspension and device bans." },
];

export default function SafetyCenter() {
  return (
    <>
      <Helmet>
        <title>Safety Center — Instafrnd</title>
        <meta name="description" content="Learn how Instafrnd keeps you safe with multi-level verification, AI moderation, women-only mode, and a reputation system you can trust." />
        <link rel="canonical" href="https://instafrnd.com/safety" />
        <meta property="og:url" content="https://instafrnd.com/safety" />
        <meta property="og:title" content="Safety Center — Instafrnd" />
        <meta property="og:description" content="Learn how Instafrnd keeps you safe with multi-level verification, AI moderation, women-only mode, and a reputation system you can trust." />
      </Helmet>
      <PageHero
        eyebrow="Safety Center"
        title="Your safety is the product."
        subtitle="Instafrnd was built for Bharat with trust at its core. Here's how we keep every conversation safe, respectful, and real."
      />

      <section className="section-pad">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">How we protect you</div>
            <h2>Six layers of trust &amp; safety.</h2>
          </div>
          <div className="card-grid">
            {PILLARS.map((p, k) => (
              <div className="info-card reveal" key={k} style={{ transitionDelay: `${(k % 3) * 0.08}s` }}>
                <div className="ic">{p.ic}</div>
                <h3>{p.h}</h3>
                <p>{p.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="features">
        <div className="wrap content-narrow prose reveal">
          <div className="kicker" style={{ justifyContent: "flex-start" }}>Reporting</div>
          <h2 style={{ fontSize: "clamp(26px,3.6vw,38px)" }}>See something? Report it in one tap.</h2>
          <p>
            Every profile, room, and message has a report button. Reports are reviewed
            around the clock, and we act fast — from warnings to permanent device bans for
            serious violations.
          </p>
          <h3>What to report</h3>
          <p>
            Harassment or bullying, nudity or sexual content, requests for money,
            impersonation, hate speech, or anyone asking to move the conversation
            off-platform to avoid moderation.
          </p>
          <h3>What happens next</h3>
          <p>
            You'll get an acknowledgement, the report goes to our trust &amp; safety team,
            and we follow up on the action taken. Emergency concerns are escalated
            immediately.
          </p>
          <div style={{ marginTop: 26 }}>
            <Link className="btn btn-primary" to="/celeb-connect">Contact our team →</Link>
          </div>
        </div>
      </section>
    </>
  );
}
